<p-menu #menu [model]="buttonMenu" [popup]="true" [appendTo]="'body'"></p-menu>
<p-inputGroup>
    <input
        [formControl]="formControl"
        [formlyAttributes]="field"
        [pAutoFocus]="true"
        [autofocus]="props?.autofocus"
        pInputText
    />
    <p-button
        [loading]="loadingSig()"
        *ngIf="!this.formControl.value"
        icon="fa fa-caret-down"
        (onClick)="menu.toggle($event)"
        class="rounded-r bg-primary-500"
        [attr.data-testid]="'formly-number-gen-expand-button'"
    ></p-button>
</p-inputGroup>
